import Debit from './Debit-view';

export default Debit;
